import React, { useContext } from "react";
import { ColorContext } from "..";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import styled from "styled-components";

const StyledNav = styled.nav`
    text-align: end;
    font-size: 2rem;
    height: 10vh;
`;

const Anchor = styled.a`
    padding: 0.5rem;
`;

function Navbar() {
    const color = useContext(ColorContext);
    return (
        <StyledNav>
            <Anchor href="https://www.linkedin.com/in/nikhilbhargav" target='_blank' rel='noreferrer'><FaLinkedin color={color} /></Anchor>
            <Anchor href="https://www.github.com/sshnuke333" target='_blank' rel='norefferer'><FaGithub color={color} /></Anchor>
        </StyledNav>
    )
};

export default Navbar;